import React from "react";
import { Modal, Table, FormControl } from "react-bootstrap"
import CurrencyInput from "react-currency-input";
import LoadingInput from "../../../../../../../_components/LoadingInput"
import Button from "../../../../../../../_components/Button"

import { getUnits, createUnit } from "../../../../../../../api/products"
import { CreateNFeContext } from "../../../Context";


export default () => {
    const [show, ShowModal] = React.useState(false)
    const [volumeData, setVolumeData] = React.useState({ unit_name: "" })
    const [loading, setLoading] = React.useState(false)
    const [units, setUnits] = React.useState([])

    const context = React.useContext(CreateNFeContext)

    async function openModal() {
        setLoading(true)
        ShowModal(true)

        await getUnits().then(units => {
            setUnits(units.reverse())
            setVolumeData({ quantity: 1 })
            setTimeout(() => {
                try {
                    document.querySelector('[name="unit_name"]').focus()
                } catch (error) {

                }
            }, 100)
        })
        setLoading(false)
    }
    function closeModal() {
        if (loading) {
            return
        }
        ShowModal(false)
        setVolumeData({ unit_name: "" })
    }
    async function saveVolume() {
        const { addVolume } = context["handlers"]
        const sameUnit = units.filter(unit => unit.name.toLowerCase() === volumeData.unit_name.toLowerCase())
        if (!sameUnit.length) {
            setLoading(true)
            await createUnit({ name: volumeData.unit_name })
                .then(data => {
                    addVolume({
                        ...volumeData,
                        unit_name: data.name,
                        unit: data.id
                    })
                })
        } else {
            addVolume({
                ...volumeData,
                unit_name: sameUnit[0].name,
                unit: sameUnit[0].id
            })
        }

        closeModal()
        setLoading(false)
    }

    function onChange(e) {
        const { name: key, value } = e.target
        const data = { ...volumeData }
        const sameUnit = units.filter(unit => unit.id === value)
        if (sameUnit.length) {
            data["unit_name"] = sameUnit[0].name
        }
        data[key] = value
        setVolumeData(data)
    }
    function handleChangePrecision(string, double, e) {
        const { name: key } = e.target
        const data = { ...volumeData }
        data[key] = double
        setVolumeData(data)
    }

    return <CreateNFeContext.Consumer>
        {
            context => {

                const { volumes } = context.nfe
                const { removeVolume } = context.handlers

                return <React.Fragment>

                    <Button
                        data-cy-test="#nfe-issuer-button-open-modal-add-volumes"
                        onClick={openModal}
                        size="sm">
                        Adicionar volumes
                    </Button>
                    {
                        volumes.length
                            ? <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Qtd.</th>
                                        <th>Espécie</th>
                                        <th>Marca</th>
                                        <th>Numeração dos volumes</th>
                                        <th>Peso L.</th>
                                        <th>Peso B.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        volumes.map((volume, index) => {
                                            const key = `nfe-issuier-volume-${index}`
                                            const quantity = volume.quantity
                                            const unit = volume.unit_name || "-"
                                            const brand = volume.brand || ""
                                            const netWeight = volume.net_weight || "0"
                                            const grossWeight = volume.gross_weight || "0"
                                            const number = volume.number || "0"

                                            return <tr key={key}>
                                                <td> {quantity} </td>
                                                <td> {unit} </td>
                                                <td>{brand}</td>
                                                <td>{number}</td>
                                                <td>{netWeight}</td>
                                                <td>{grossWeight}</td>
                                                <td>
                                                    <i
                                                        onClick={() => removeVolume(index)}
                                                        style={{ cursor: "pointer", fontSize: ".8em", }}
                                                        className="fas fa-trash-alt btn btn-outline-danger btn-sm mr-3" />
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </Table>
                            : <span />
                    }
                    <Modal show={show} size="lg" onHide={closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <h2>
                                    Adicionar Volume à NF-e
                                </h2>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="form-label">
                                            Espécie
                                        </div>
                                        <div>
                                            <LoadingInput
                                                disabled={loading}
                                                name="unit_name"
                                                data-cy-test="#nfe-issuer-add-volumes-input-unit-name"
                                                value={volumeData.unit_name}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className={!volumeData.unit_name ? "alert alert-warning mt-2" : "d-none"} role="alert">
                                            Informe a espécie
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-xs-12">
                                    <div className="row">


                                        <div className="form-group">
                                            <div className="form-label">
                                                Quantidade de volumes
                                            </div>
                                            <LoadingInput
                                                name="quantity"
                                                type="number"
                                                data-cy-test="#nfe-issuer-add-volumes-input-quantity"
                                                min={1}
                                                disabled={loading}
                                                value={volumeData["quantity"]}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="px-2"></div>
                                        <div className="form-group">
                                            <div className="form-label">
                                                Marca dos volumes
                                            </div>
                                            <LoadingInput
                                                data-cy-test="#nfe-issuer-add-volumes-input-brand"
                                                disabled={loading}
                                                name="brand"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="form-group px-2">
                                            <div className="form-label">
                                                Numeração dos volumes
                                            </div>
                                            <LoadingInput
                                                name="number"
                                                type="number"
                                                min={1}
                                                disabled={loading}
                                                value={volumeData["number"]}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <div className="form-label">
                                                Peso líquido ( Em kg )
                                            </div>
                                            <CurrencyInput
                                                data-cy-test="#nfe-issuer-add-volumes-input-net-weight"
                                                name="net_weight"
                                                className="form-control"
                                                decimalSeparator=","
                                                thousandSeparator="."
                                                precision="3"
                                                disabled={loading}
                                                value={volumeData["net_weight"]}
                                                onChange={handleChangePrecision}
                                            />
                                        </div>
                                        <div className="px-2"></div>
                                        <div className="form-group">
                                            <div className="form-label">
                                                Peso bruto ( Em kg )
                                            </div>
                                            <CurrencyInput
                                                disabled={loading}
                                                name="gross_weight"
                                                data-cy-test="#nfe-issuer-add-volumes-input-gross-weight"
                                                className="form-control w-100"
                                                decimalSeparator=","
                                                thousandSeparator="."
                                                precision="3"
                                                value={volumeData["gross_weight"]}
                                                onChange={handleChangePrecision}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                data-cy-test="#nfe-issuer-button-save-new-volume"
                                disabled={loading || !volumeData.unit_name}
                                onClick={saveVolume}>
                                Salvar volume
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            }
        }
    </CreateNFeContext.Consumer>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/ShippingTransporter/NFeVolumes/index.jsx